export function objectsHaveSameKeys(...objects) {
  if (objects.length === 0) { return true; }

  const keys = objects.map((obj) => Object.keys(obj).sort());

  return keys.every((keyArray) => JSON.stringify(keys[0]) === JSON.stringify(keyArray));
}
